
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acerca-de-spotme/[topic]/[slug]",
      function () {
        return require("private-next-pages/acerca-de-spotme/[topic]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acerca-de-spotme/[topic]/[slug]"])
      });
    }
  